// Module
var code = "<html> <body> <script>(window.opener||window.parent).postMessage(location.hash||\"#\"+location.search,location.origin)</script> </body> </html> ";
// Exports
export default code;